import React from 'react';
import { CtaButton } from './CtaButton';
import { tomos, CTA_LABEL } from '../data/content';
export function TomosSection() {
  return <section className="w-full bg-canvas px-4 py-9 sm:px-6 sm:py-12" data-id="element-174" data-mp="1kbak9s8k099j">
      <div className="mx-auto max-w-5xl" data-id="element-175" data-mp="1p3agpapf0k1d">
        <div className="mx-auto max-w-2xl text-center" data-id="element-176" data-mp="1p5n4i4hutomc">
          <h2 className="font-display text-[1.25rem] font-extrabold uppercase leading-tight text-brand-deep sm:text-3xl" data-id="element-177" data-mp="1u1lnfckeyefd">
            Un reset. 6 herramientas.{' '}
            <span className="text-brand" data-id="element-178" data-mp="11dzmyd6hfpwq">Un solo plan.</span>
          </h2>
          <p className="mx-auto mt-2 max-w-lg text-[0.85rem] leading-snug text-gray-600 sm:text-base" data-id="element-179" data-mp="11g292m4ikyw6">
            No necesitas leer seis libros antes de comenzar. Cada tomo cumple
            una función dentro del método: qué hacer primero, qué ajustar
            después y cómo continuar.
          </p>
        </div>

        <ul className="mt-5 grid grid-cols-2 gap-2.5 sm:mt-6 sm:gap-4 lg:grid-cols-3" data-id="element-180" data-mp="2mrc1xmpyjic0">
          {tomos.map(tomo => <li key={tomo.numero} className="flex h-full flex-col overflow-hidden rounded-xl border border-gray-200 bg-white" data-id="element-181" data-mp="2qoqmey1yd2z0">
              <div className="bg-brand-soft px-4 py-3 sm:px-6 sm:py-4" data-id="element-182" data-mp="2mksmil4szo4w">
                <img src={tomo.portada} alt={`Portada del ${tomo.numero}: ${tomo.titulo}`} loading="lazy" className="mx-auto aspect-[2/3] w-full max-w-[9rem] rounded object-cover shadow-lg shadow-brand/20 sm:max-w-[10rem]" data-id="element-183" data-mp="2hlpkl9k4dy15" />
              </div>

              <div className="flex flex-1 flex-col p-3 text-left sm:p-4" data-id="element-184" data-mp="1yx2huxpf1kqq">
                <span className="font-display text-[0.6rem] font-extrabold uppercase tracking-[0.15em] text-brand" data-id="element-185" data-mp="1yuyeqhzccpri">
                  {tomo.numero}
                </span>
                <h3 className="mt-0.5 font-display text-[0.9rem] font-extrabold uppercase leading-tight text-brand-deep sm:text-base" data-id="element-186" data-mp="1oxjzumt2g91b">
                  {tomo.titulo}
                </h3>
                <p className="mt-1 font-display text-[0.62rem] font-extrabold uppercase tracking-wider text-accent sm:text-[0.7rem]" data-id="element-187" data-mp="1ab4qc8jv030m">
                  {tomo.beneficio}
                </p>
                <p className="mt-1.5 text-[0.78rem] leading-snug text-gray-600 sm:text-sm" data-id="element-188" data-mp="11c9n95c4391j">
                  {tomo.resumen}
                </p>
              </div>
            </li>)}
        </ul>

        <p className="mx-auto mt-5 max-w-xl text-center font-display text-[0.95rem] font-extrabold uppercase leading-snug text-brand-deep sm:text-lg" data-id="element-189" data-mp="1t3p5kn6my9ly">
          6 herramientas.{' '}
          <span className="text-brand" data-id="element-190" data-mp="1kavp4mfgd46i">Un solo sistema.</span>
        </p>

        <div className="mx-auto mt-4 max-w-md" data-id="element-191" data-mp="1k8j4u2m82hqa">
          <CtaButton href="#precio" location="tomos" data-id="element-192" data-mp="1oaw3k72jxfdk">
            {CTA_LABEL}
          </CtaButton>
        </div>
      </div>
    </section>;
}